export default {
    url: '/edit/:id',
    template: `
        <manage-settings-tasklist-templates-edit
            tasklist-template="vm.tasklistTemplate"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
        />`,
    resolve: {
        tasklistTemplate (TasklistTemplateResource, $stateParams) {
            return TasklistTemplateResource.get({ id: $stateParams.id, expand: 'templateTasks.file,templateTargets,templateTargetsWithValue,templateConditions' }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        }
    },
    controller (tasklistTemplate, classifiers, CLASSIFIER_ENUM) {
        this.tasklistTemplate = tasklistTemplate;
        this.departments = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/tasklist/templates/edit/index.js